import { clearLocalStorage } from "app/localStorage/token"
import { isSwitchedToBeta } from "app/switch/appSwitch"
import { parseToken } from "utils/utils"

export type BetaStart = "callback" | "login" | "old-app" | "render"

// The beta's side of the switch: only users Thomas switched in Auth0 stay here
export function decideBetaStart(path: string, accessToken: string | null, now = Date.now(), hash = ""): BetaStart {
  // auth0-js never settles parseHash without a login result in the hash, so only a real callback waits for it
  if (path === "/callback" && hash) return "callback"
  let exp = 0
  try {
    exp = parseToken(accessToken!)?.exp ?? 0
  } catch {
    // no token or not a JWT: log in
  }
  if (exp * 1000 <= now) return "login"
  return isSwitchedToBeta(accessToken, now) ? "render" : "old-app"
}

// Each origin keeps its own tokens, so logging out of the old app leaves the beta logged in
export function logOut(auth0Logout: () => void): void {
  clearLocalStorage()
  auth0Logout()
}

// ?stay=1 stops the old app from sending the user straight back here
export const oldAppUrl = (base: string): string => `${base}/?stay=1`

type LoginSteps = {
  authenticate: () => Promise<{ accessToken: string; idToken: string }>
  storeAccessToken: (t: string) => void
  storeIdToken: (t: string) => void
  logout: () => void
  report: (error: unknown) => void
  done: () => void
}

// A failed callback logs out instead of logging in again: with a live Auth0 session,
// authorize() would come straight back here with the same error, forever
export async function finishLogin(steps: LoginSteps): Promise<void> {
  try {
    const { accessToken, idToken } = await steps.authenticate()
    steps.storeAccessToken(accessToken)
    steps.storeIdToken(idToken)
  } catch (error) {
    steps.report(error)
    steps.logout()
    return
  }
  steps.done()
}
